// As linguas do CARTAO da transcricao, e so do cartao.
//
// PORQUE E QUE ISTO NAO ESTA NO `translations`
// O `t()` do index.js resolve `translations[lingua]?.[chave] || translations.en[chave]`,
// portanto uma lingua que ele nao conheca nao cai na lingua do backoffice, cai
// em INGLES. O cartao pede as suas legendas na lingua do CHAT e nao na do
// operador (ver useCardTranslate), que e o que o poe a dizer o mesmo que o
// cliente leu. Com o MODZ, que fala `fr`, o resultado era um cartao a dizer
// "VIEW PRODUCT" e "Size:" dentro de uma consola em portugues, quando o
// cliente tinha visto "VOIR LE PRODUIT" e "T :".
//
// Estes dicionarios sao PARCIAIS de proposito: so tem as chaves que o cartao
// usa. Por isso e que nao entram no `translations` do index.js, onde pareciam
// linguas inteiras do backoffice e um dia alguem trocava a consola para `fr` e
// via metade dela em ingles. Ninguem alem do useCardTranslate lhes chega.
//
// As cadeias sao as do widget, copiadas de app/src/ui/i18n/<lingua>.json. Nao
// se traduz aqui nada por conta propria: se o widget mudar a legenda, esta
// tabela fica velha, e o sitio de onde ela veio esta escrito aqui para o
// proximo saber onde ir buscar a nova.
const fr = {
  productCardViewProduct: "Voir le produit",
  productCardSizesLabel: "T :",
  productCardPrevious: "Produit précédent",
  productCardNext: "Produit suivant",
  productCardCarouselLabel: "Produits recommandés",
  productCardRecommendedPriceLabel: "Prix conseillé",
  productCardPriceBadgeOverRecommended: "vs prix conseillé",
  productCardPriceBadgeDirect: "DIRECT",
  productCardDeliveryBusinessDays: "Livraison en {min} à {max} jours ouvrés",
  productCardDeliveryBusinessDaysExact: "Livraison en {days} jours ouvrés",
  productCardDeliveryBusinessDaysOne: "Livraison en 1 jour ouvré",
  productCardDeliveryUpTo: "Livraison sous {max} jours",
  productCardDeliveryUpToOne: "Livraison sous 1 jour",
  productCardAvailabilityTemporarilyUnavailable: "Temporairement indisponible",
  productCardAvailabilityPreorder: "Livraison à la date de sortie",
  productCardPriceInfo: "Informations sur les prix",
};

const es = {
  productCardViewProduct: "Ver producto",
  productCardSizesLabel: "Talla:",
  productCardPrevious: "Producto anterior",
  productCardNext: "Siguiente producto",
  productCardCarouselLabel: "Productos recomendados",
  productCardRecommendedPriceLabel: "PVPR",
  productCardPriceBadgeOverRecommended: "sobre PVPR",
  productCardPriceBadgeDirect: "DIRECTO",
  productCardDeliveryBusinessDays: "Entrega en {min} a {max} días laborables",
  productCardDeliveryBusinessDaysExact: "Entrega en {days} días laborables",
  productCardDeliveryBusinessDaysOne: "Entrega en 1 día laborable",
  productCardDeliveryUpTo: "Entrega en hasta {max} días",
  productCardDeliveryUpToOne: "Entrega en hasta 1 día",
  productCardAvailabilityTemporarilyUnavailable: "Temporalmente no disponible",
  productCardAvailabilityPreorder: "Entrega en la fecha de lanzamiento",
  productCardPriceInfo: "Información sobre precios",
};

// `pt` e `en` ficam de fora: para essas duas o `t()` ja responde, e com as
// mesmas cadeias, porque o pt.js e o en.js daqui foram escritos do mesmo sitio.
export const cardLocales = { fr, es };
